import { Button } from "antd";
import { copyToClipBoard } from "../lib/utils";
export function fallbackRender({ error, resetErrorBoundary }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(246, 248, 250, 1)",
        position: "fixed",
        textAlign: "center",
        alignContent: "center",
      }}
    >
      <div style={{ width: "500px", height: "538px", display: "inline-block" }}>
        <img
          width="270px"
          height="200px"
          src="/fallback.png"
          style={{ display: "inline" }}
        />
        <div style={{ fontWeight: "600", fontSize: "34px", marginTop: "12px" }}>
          Oops! Something went wrong.
        </div>
        <div style={{ fontSize: "16px", marginTop: "18px" }}>
          We encountered an unexpected error. Our team is already working to
          resolve it.
        </div>
        <div style={{ fontSize: "16px", marginTop: "18px" }}>
          Error Details: {error.message}
        </div>
        <div style={{ fontSize: "16px", marginTop: "18px" }}>
          If you'd like to help us investigate, please
          <span
            style={{ color: "rgba(62, 131, 246, 1)", cursor: "pointer" }}
            onClick={() => copyToClipBoard(error.stack)}
          >
            {" "}
            copy the error information{" "}
          </span>
          and send it to dev@agi7.ai.
        </div>
        <div style={{ marginTop: "18px" }}>
          <Button className="primaryButton" onClick={resetErrorBoundary}>
            Return to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
